import React from "react";
import {
	Box,
	Grid,
	Collapse,
	IconButton,
	Typography,
} from "@mui/material";
import {
	KeyboardArrowUp as KeyboardArrowUpIcon,
	KeyboardArrowDown as KeyboardArrowDownIcon,
} from "@mui/icons-material";
import {makeStyles} from "@mui/styles";
import {useSelector} from "react-redux";
import {convertNewlinesToBreaks} from "../../../../../helper/convertor";


const UserInfo = (props) => {
	const {
		client,
		reasonForContacting
	} = props;
	const classes = useStyles();
	const {user} = useSelector(state => state.global);

	const [isCollapsed, setIsCollapsed] = React.useState(window.innerWidth > 1024);
	const IconCollapes = isCollapsed ? KeyboardArrowUpIcon : KeyboardArrowDownIcon;
	const handleChangeCollapsed = (val) => {
		setIsCollapsed(val)
	};

	const getClientName = () => {
		if (client.isLegal) {
			return (
				<>
					<Grid item>
						Компания - {client?.companyName || 'Нет данных о компании'}
					</Grid>
					{user?.role !== 'mechanic' && (
						<Grid item>
							Номер телефона - <b>{client?.phone || "Нет данных о номере"}</b>;
						</Grid>
					)}
				</>
			);
		}

		const fullName = [
			client?.lastName || '',
			client?.firstName || '',
			client?.patronymic || '',
		].filter((t) => !!t).join(' ');

		return (
			<>
				<Grid item>
					ФИО - <b>{fullName}</b>;
				</Grid>
				<Grid item>
					Номер телефона - <b>{client?.phone || "Нет данных о номере"}</b>;
				</Grid>
			</>
		);
	};

	return (
		<>
			<Box onClick={() => handleChangeCollapsed(!isCollapsed)}>
				<Grid container alignItems="center" justifyContent="space-between">
					<Grid item>
						<Typography variant="h3" textAlign="left">Информация о клиенте</Typography>
					</Grid>
					<Grid item>
						<IconCollapes sx={{color: "#FF3F3F"}}/>
					</Grid>
				</Grid>
			</Box>

			<Collapse in={isCollapsed}>
				<Grid className={classes.root} container spacing={1} mt={1}>
					{getClientName()}
					<Grid item xs={12}>
						Причина обращения - <div dangerouslySetInnerHTML={{__html: convertNewlinesToBreaks(String(reasonForContacting || 'Неизвестно'))}}/>
					</Grid>
				</Grid>
			</Collapse>
		</>
	);
};

const useStyles = makeStyles(() => ({
	root: {
		"& b": {
			fontWeight: "500",
			textDecoration: "underline"
		}
	}
}));

export default React.memo(UserInfo)
